import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class lists with conflict resolution.
 * Used by every shadcn primitive.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Date/time formatters live in `@/lib/format` as the single source of truth.
 * Re-exported here for backwards compatibility with existing imports.
 */
export { formatDate, formatDateTime, formatRelative, todayIsoDate } from './format';
